import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { PositionsDataPayload, PositionsDataResponse } from "@/types/interface/position";

async function createPosition(payload: PositionsDataPayload) {
  return await http.post<APIResponse<PositionsDataResponse>>("job/create", payload);
}

async function updatePosition(idPosition = '', payload: PositionsDataPayload) {
  return await http.patch<APIResponse<PositionsDataResponse>>(`job/update?id=${idPosition}`, payload);
}

async function getPosition(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<PositionsDataResponse>>(`job?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findPosition(idPosition = "") {
  return await http.get<APIResponse<PositionsDataResponse>>(`job/detail?id=${idPosition}`);
}

async function deletePosition(idPosition = "") {
  return await http.delete<APIResponse<PositionsDataResponse>>(`job/delete?id=${idPosition}`);
}

export default {
  createPosition,
  updatePosition,
  getPosition,
  findPosition,
  deletePosition
};